import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  savedFilters: null,
};

const regionalDetailsSlice = createSlice({
  name: "regionalDetails",
  initialState,
  reducers: {
    saveRegionalFilters: (state, action) => {
      state.savedFilters = action.payload;
    },
    clearRegionalFilters: (state) => {
      state.savedFilters = null;
    },
  },
});

export const { saveRegionalFilters, clearRegionalFilters } = regionalDetailsSlice.actions;
export const selectRegionalSavedFilters = (state) => state.regionalDetails.savedFilters;
export default regionalDetailsSlice.reducer;
